import React from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../../../../../utilities";
import SiteHeaderPanel from "../../../Panel";

var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      id = _ref.id,
      tabTitle = _ref.tabTitle,
      setOpenPanel = _ref.setOpenPanel,
      currentOpenPanel = _ref.currentOpenPanel,
      defaultOpenPanel = _ref.defaultOpenPanel;
  var getClassName = getClassNameFactory(TabPanel.displayName);
  return /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": "tab-".concat(id),
    role: "tabpanel",
    className: getClassName({
      states: classNames({
        visibleAtSiteHeaderViewport: currentOpenPanel === id || currentOpenPanel === null && defaultOpenPanel === id
      })
    }),
    "data-rehydratable": getRehydratableName(TabPanel.displayName),
    "data-tab-title": tabTitle,
    id: id,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(SiteHeaderPanel, {
    onBack: function onBack() {
      setOpenPanel(null);
    },
    open: currentOpenPanel === id,
    title: tabTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "children"
    })
  }, children)));
};

TabPanel.defaultProps = {
  // these props are provided by by prop drilling from flyouts
  setOpenPanel: function setOpenPanel() {},
  currentOpenPanel: "",
  defaultOpenPanel: ""
};
TabPanel.displayName = "SiteHeader.Flyouts.TabPanel";
export default TabPanel;